module.exports = __webpack_public_path__ + "static/img/blo7.9a8d5fee.png";